<template>
  <div class="col-xl-4">
    <article class="article-item home-featured">
      <div class="article-wrap">
        <div class="article-thumbnail">
          <div class="img-box">
            <a :href="getMatchLink(featuredTeam)">
              <img
                class="lazy"
                src="https://www.fantasygully.com/static-assets/images/cssimages/default-lazy-rect.png?w=130"
                :data-src="getImageUrl(featuredTeam)"
                :alt="featuredTeam.title_alias"
              />
            </a>
          </div>
        </div>
        <div class="article-content">
          <a :href="getMatchLink(featuredTeam)">
            <div class="match-item">
              <!-- <div class="match-date">
              29<sup>th</sup>
              Apr 2022 | 3:30 PM
            </div> -->
              <div class="match-data">
                <div class="team team-A">
                  <div class="team-name">
                    <p class="article-title">{{ featuredTeam.asset_title }}</p>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  props: ["featuredTeam", "translations", "pageUrl"],
  methods: {
    getImageUrl(match) {
      return `https://www.fantasygully.com/static-assets/waf-images/${match.image_path}130-450/${match.image_file_name}`;
    },
    getMatchLink(match) {
      return `https://www.fantasygully.com/${this.pageUrl}/${match.title_alias}`;
    },
  },
};
</script>